<template>
  <div class="budgetExpenditure">
    <div class="budgetExpenditure_titleArea">
      <h3 class="title">预算花费</h3>
    </div>
    <div class="budgetExpenditure_main">
      <div class="main_item">
        <div class="item_title">
          <span class="title">预算花费</span>
        </div>
        <div class="item_main">
          <div class="main_input">
            <el-input
              v-model="budgetext"
              placeholder="请输入内容"
              size="small"
              type="number"
              @input="setMoney"
            />
            <span class="text">元/天</span>
          </div>
          <span class="main_tips">每日预算有效范围为50-40,000,000元/天</span>
        </div>
      </div>

      <div class="main_item">
        <div class="item_title">
          <span class="title">出价</span>
        </div>
        <div class="item_main">
          <div class="main_input">
            <el-input
              v-model="offertext"
              placeholder="请输入内容"
              size="small"
              type="number"
              @input="setMoneyone"
            />
            <span class="text">元/千次曝光</span>
          </div>
          <span class="main_tips">广告出价，有效范围为1.5-999元/千次曝光</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    budget1: {},
    offer1: {},
    budget: {},
    bid: {}
  },
  data() {
    return {
      budgetext: '',
      offertext: ''
    }
  },
  created() {
    this.budgetext = this.budget / 100
    this.offertext = this.bid / 100
  },
  methods: {
    setMoney(e) {
      console.log('e', e)
      this.$emit('budgetext', Number(e) * 100)
    },
    setMoneyone(e) {
      this.$emit('offertext', Number(e) * 100)
      console.log('e', e)
    }
  }
}
</script>

<style scoped lang="less">
.budgetExpenditure {
  width: 100%;
  padding: 0 0 32px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 6px 0 rgb(0 0 0 / 4%), 0 0 0 1px hsl(0deg 0% 87% / 50%);
  margin-bottom: 12px;
  .budgetExpenditure_titleArea {
    padding: 18px 24px;
    border-bottom: 1px solid #f2f2f2;
    .title {
      margin-bottom: 2px;
      font-size: 14px;
      line-height: 24px;
      color: #1f1f1f;
      font-weight: 600;
    }
  }
  .budgetExpenditure_main {
    /* padding: 0px 24px; */

    .main_item {
      padding: 20px 24px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgb(242, 242, 242);
      .item_title {
        width: 110px;
        .title {
        }
      }
      .item_main {
        .main_input {
          display: flex;
          align-items: center;
          .el-input {
            width: 50%;
          }
          .text {
            display: inline-block;
            margin-left: 5px;
          }
        }
        .main_tips {
          display: inline-block;
          margin-top: 5px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
